(function(){
  'use strict';

  angular.module('irricrops')


  .factory("VinedoRes", ['urls', '$resource', function(urls, $resource){
    return $resource(urls.BASE+'/vinedo/:action', {},{



      //----------
      // GET
      //----------

      get:{
        method: 'GET',
        cache: true
      },
      getResumen:{
        method: 'GET',
        params:{
          action: 'resumen'
        }
      },
      getEt:{
        method: 'GET',
        params:{
          action: 'evapotranspiracion'
        }
      },
      getMap:{
        method: 'GET',
        params:{
          action: 'mapa'
        }
      },
      getKc:{
        method: 'GET',
        params:{
          action: 'kc'
        }
      },
      calidades:{
        method: 'GET',
        params:{
          action: 'calidades'
        }
      },
      variedades:{
        method: 'GET',
        params:{
          action: 'variedades'
        }
      },
      getPrecip:{
        method: 'GET',
        params:{
          action: 'precipitacion'
        }
      },
      getTemp:{
        method: 'GET',
        params:{
          action: 'temperatura'
        }
      },
      getCalicatas:{
        method: 'GET',
        params:{
          action: 'calicatas'
        }
      },
      getSensores:{
        method: 'GET',
        params:{
          action: 'sensores'
        }
      },
      getScholanderData:{
        method: 'GET',
        params:{
          action: 'sectores-scholander'
        }
      },
      getSectoresData:{
        method: 'GET',
        params:{
          action: 'sectores-riego'
        }
      },
      getCuartelesData:{
        method: 'GET',
        params:{
          action: 'cuarteles'
        }
      },
      getEstadosFenologicos:{
        method: 'GET',
        params:{
          action: 'estados-fenologicos'
        }
      },

      getEstacion:{
        method: 'GET',
        params:{
          action: 'datos-estacion'
        }
      },

      getGradosDia:{
        method: 'GET',
        params:{
          action: 'grados-dias'
        }
      },



      //----------
      // POST
      //----------

      etb:{
        method: 'POST',
        params:{
          action: 'etb'
        }
      },
      precipitacion:{
        method: 'POST',
        params:{
          action: 'precipitacion'
        },
      },
      eto:{
        method: 'POST',
        params:{
          action: 'eto'
        },
      },
      temperaturamed:{
        method: 'POST',
        params:{
          action: 'temperatura-med'
        }
      },
      temperaturamin:{
        method: 'POST',
        params:{
          action: 'temperatura-min'
        }
      },
      temperaturamax:{
        method: 'POST',
        params:{
          action: 'temperatura-max'
        }
      },


    });
  }])



  .factory("VinedoFac", ['VinedoRes', 'newCacheManager', '$q', 'global',
  function(VinedoRes, NCM, $q, global){
    var cache      = function(a){
      var nameData = a.nameData;
      var id       = a.id;
      var date     = a.date || null;
      var data     = {};
      var dataAjax = a.dataAjax;
      var thenFn   = a.thenFn;
      var fn       = a.fn;
      var defered  = null;
      var prom     = null;
      var dateUnix = moment(date).unix();

      if (angular.isDefined(NCM.get(nameData, id, dateUnix))) {
        defered = $q.defer();
        prom = defered.promise;
        data = {
          data: NCM.get(nameData, id, dateUnix),
          errors: false
        };
        defered.resolve(data);
        thenFn(data);
      }else{
        prom = VinedoRes[fn](dataAjax).$promise;
        prom.then(thenFn);
        prom.then(function(data){
          NCM.set(nameData, id, data.data, dateUnix);
        });
      }
      return prom;
    };



    return {
          getData: function(id, fecha){
            return VinedoRes.get({vinedo_id: id, fecha:fecha});
          },

          getEt: function (data, thenFn) {
            return cache({
              nameData: "vinedo.evapotranspiracion",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getEt'
            });
          },


          getMap: function (data, thenFn) {
            return cache({
              nameData: "vinedo.mapa",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getMap'
            });
          },


          //simula ser vinedoRes.getEt()
          getKc: function (data, thenFn) {
            return cache({
              nameData: "vinedo.kc",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getKc'
            });
          },

          getPrecip: function (data, thenFn) {
            return cache({
              nameData: "vinedo.precipitacion",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getPrecip'
            });
          },

          getResumen: function (data, thenFn) {
            return cache({
              nameData: "vinedo.resumen",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getResumen'
            });
          },

          getTemp: function (data, thenFn) {
            return cache({
              nameData: "vinedo.temperatura",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getTemp'
            });
          },




          getCalidades: function (data, thenFn) {
            return cache({
              nameData: "vinedo.calidades",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'calidades'
            });
          },

          getVariedades: function (data, thenFn) {
            return cache({
              nameData: "vinedo.variedades",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'variedades'
            });
          },

          getSensores: function (data, thenFn) {
            return cache({
              nameData: "vinedo.sensores",
              id: data.vinedo_id,
              dataAjax: data,
              date: data.fecha || null,
              thenFn: thenFn,
              fn: 'getSensores'
            });
          },






      //POST
      etb:function(data, thenFn){
        var id = data.vinedo_id;
        var prom = VinedoRes.etb(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.vinedo.et",
              id,
              global.getChildren('vinedo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },



      eto:function(data, thenFn){
        var id = data.vinedo_id;
        var prom = VinedoRes.eto(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.vinedo.et",
              id,
              global.getChildren('vinedo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },

      temperaturamin:function(data, thenFn){
        var id = data.vinedo_id;
        var prom = VinedoRes.temperaturamin(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.vinedo.temperatura",
              id,
              global.getChildren('vinedo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },

      temperaturamed:function(data, thenFn){
        var id = data.vinedo_id;
        var prom = VinedoRes.temperaturamed(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.vinedo.temperatura",
              id,
              global.getChildren('vinedo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },

      temperaturamax:function(data, thenFn){
        var id = data.vinedo_id;
        var prom = VinedoRes.temperaturamax(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.vinedo.temperatura",
              id,
              global.getChildren('vinedo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },

      precipitacion:function(data, thenFn){
        var id = data.vinedo_id;
        var prom = VinedoRes.precipitacion(data).$promise;
        prom.then(function(data){
          NCM.action(
              "add.vinedo.precipitacion",
              id,
              global.getChildren('vinedo',id),
              0 //borra de todas las fechas
              );
        });
        prom.then(thenFn);
        return prom;
      },




    };

  }]);
})();
